export default {
  content: {
    message: 'Visita nuestro blog',
    title: 'Visita nuestro blog',
    messageButton: 'Nuestro blog',
    text: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore e' +
    'nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt'
  }
}



// WEBPACK FOOTER //
// ./src/i18n/es/blog.js